import {ComponentModalConfig, ModalSize, SuiModal} from '@angular-ex/semantic-ui';
import {Component} from '@angular/core';

import {Article} from '../../../../core/models/articles/articles.model';

interface IDuplicateModalContext {
  possibleDuplicateArticles: Article[];
}

@Component({
  selector: 'app-duplicate-modal',
  templateUrl: './duplicate-modal.component.html',
  styleUrls: ['./duplicate-modal.component.css'],
  standalone: false,
})
export class DuplicateModalComponent {
  constructor(
    protected modal: SuiModal<IDuplicateModalContext, void, void>,
  ) {
  }
}

export class DuplicateModal extends ComponentModalConfig<IDuplicateModalContext, void, void> {
  constructor(possibleDuplicateArticles: Article[], size = ModalSize.Small) {
    super(DuplicateModalComponent, {possibleDuplicateArticles});

    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
  }
}
